import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';

import { RadioGroupInput } from '../../../components/radioGroupInput/RadioGroupInput';
import { adaptAdicionalesIdsContrato, GET_ADICIONALES_CONTRATO } from '../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getAdicionalesContrato';
import { getStringQueryCombosRI } from '../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../adapters/resumenIngreso/combosRIAdapter';
import { adaptAdicionalArray } from '../../../adapters/adicionalComboAdapter';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CREATE_ADICIONAL_EVALUACION } from '../../../data/graphQL/mutations/ResumenIngresoValidation/CreateAdicionalEvaluacion';
import './adicional.scss';

export const AdicionalInput = ({
  idEvaluacion,
  readOnly
}) => {
  const [adicionales, setAdicionales] = useState({ adicionalesEvaluacion: [] });
  const [adicionalesOptions, setAdicionalesOptions] = useState([]);

  const handleChange = (name, value) => {
    setAdicionales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const { data: combosData } = useQuery(getStringQueryCombosRI([{ name: 'idComboRIValorReqAdicional', comboName: 'Adicionales' }]), {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!combosData) return;

    const combos = adaptAdicionalArray(combosData)?.idComboRIValorReqAdicional;
    setAdicionalesOptions(combos);
  }, [combosData]);

  const [createAdicionales, { loading: adicionalesCreateLoading }] = useMutation(CREATE_ADICIONAL_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  const onSubmit = async () => {
    try {
      await createAdicionales({
        variables: {
          idEvaluacion: idEvaluacion,
          input: { idComboRIValorReqAdicional: adicionales?.adicionalesEvaluacion }
        }
      });
      toast.success('Adicionales cargados con éxito');
    } catch (err) {
      toast.error('Ocurrió un error al cargar los adicionales');
    }
  };

  const [getAdicionales, { loading: adicionalesLoading }] = useLazyQuery(GET_ADICIONALES_CONTRATO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!idEvaluacion) return;
    if (!adicionalesLoading) {
      getAdicionales({ variables: { idEvaluacion } }).
        then((res) => {
          const mappedIds = adaptAdicionalesIdsContrato(res?.data)?.requerimientosAdicionales;
          console.log({ mappedIds });

          setAdicionales({ adicionalesEvaluacion: mappedIds });
        });
    }
  }, [idEvaluacion]);

  return <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
    <CardContent>
      <div className='section-container-adicionales'>
        <div className='step-form-section-container' key={'AdicionalesEvaluacion'}>
          <div>
            <label className='step-form-section-title'>Requerimientos Adicionales</label>
            <Grid container>
              <RadioGroupInput
                adicionalValues={adicionales?.adicionalesEvaluacion}
                inputName={'adicionalesEvaluacion'}
                options={adicionalesOptions}
                onChange={handleChange}
                row={false} />

            </Grid>
          </div>
        </div>
        <div>
          <CustomButton
            isLoading={adicionalesCreateLoading}
            disabled={readOnly}
            className='margin-right'
            variant="outlined"
            onClick={() => onSubmit()}>

            Guardar Adicionales
          </CustomButton>
        </div>
      </div>
    </CardContent>
  </Card>;
};

export default AdicionalInput;